import { render } from "./Cart_Course_Item.vue?vue&type=template&id=0c953e4f&scoped=true"
import script from "./Cart_Course_Item.vue?vue&type=script&lang=js"
export * from "./Cart_Course_Item.vue?vue&type=script&lang=js"

import "./Cart_Course_Item.vue?vue&type=style&index=0&id=0c953e4f&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c953e4f"]])

export default __exports__